import { render, staticRenderFns } from "./Globalmoto.vue?vue&type=template&id=289bd7c2&scoped=true&"
import script from "./Globalmoto.vue?vue&type=script&lang=js&"
export * from "./Globalmoto.vue?vue&type=script&lang=js&"
import style0 from "./Globalmoto.vue?vue&type=style&index=0&id=289bd7c2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bd7c2",
  null
  
)

export default component.exports